import { Route } from "react-router-dom";
import PortalGuard from "../components/PortalGuard";
import PublisherLayout from "../layouts/PublisherLayout";
import PublisherDashboard from "../pages/publisher/PublisherDashboard";
import PublisherGames from "../pages/publisher/PublisherGames";
import PublisherRules from "../pages/publisher/PublisherRules";
import PublisherTutorials from "../pages/publisher/PublisherTutorials";
import PublisherEditions from "../pages/publisher/PublisherEditions";
import PublisherCampaigns from "../pages/publisher/PublisherCampaigns";
import PublisherAnalytics from "../pages/publisher/PublisherAnalytics";
import PublisherInsights from "../pages/publisher/PublisherInsights";
import PublisherProfilePage from "../pages/publisher/PublisherProfilePage";
import PublisherTeam from "../pages/publisher/PublisherTeam";
import PublisherPlan from "../pages/publisher/PublisherPlan";
import PublicPublisherPage from "../pages/PublicPublisherPage";

export function PublisherRoutes({ ProtectedRoute }) {
  return (
    <>
      <Route
        path="/publisher/:publisherId"
        element={<ProtectedRoute><PortalGuard portal="publisher_portal"><PublisherLayout /></PortalGuard></ProtectedRoute>}
      >
        <Route index element={<PublisherDashboard />} />
        <Route path="games" element={<PublisherGames />} />
        <Route path="rules" element={<PublisherRules />} />
        <Route path="tutorials" element={<PublisherTutorials />} />
        <Route path="editions" element={<PublisherEditions />} />
        <Route path="campaigns" element={<PublisherCampaigns />} />
        <Route path="analytics" element={<PublisherAnalytics />} />
        <Route path="insights" element={<PublisherInsights />} />
        <Route path="profile" element={<PublisherProfilePage />} />
        <Route path="team" element={<PublisherTeam />} />
        <Route path="plan" element={<PublisherPlan />} />
      </Route>
      <Route path="/pub/:publisherSlug" element={<PublicPublisherPage />} />
    </>
  );
}
